export { RelevantInformationModal } from './components/relevant-information/index.js';
export { destroy, setup, signUpFormConfig } from './pagcor.js';
